import { useDataLayer, usePageViews } from 'react-common-gdlv2';

const PageAnalytics = () => {
  // Adobe analytics GDLV2 instance config
  // const { getConfig } = useDataLayer();
  // Automatic page level tracking powered by pageData config
  // usePageViews(getConfig());
  return <></>;
};

export default PageAnalytics;
